import { combineReducers } from 'redux';
// eslint-disable-next-line import/no-unresolved, import/extensions
// import authReducer from './authentication/reducers';
import ChangeLayoutMode from './themeLayout/reducers';

import { loaderReducer } from './loader/loaderReducer';
// import { BookingReducer } from './booking/';
import AuthReducer from './authentication/reducers';
import ProfileReducer from './profile/reducers';
import { CustomerReducer } from './customer/reducer';
import { userReducer } from './user/reducer';
import { paymentReducer } from './payment/reducer';
import { packageReducer } from './package/reducer';
import { masterReducer } from './master/reducer';
import { sourceReducer } from './source/reducer';
import { salesAgentReducer } from './salesAgent/reducer';
import { packageSourceReducer } from './packageSource/reducer';
import { merchantRegistrationReducer } from './merchantRegistration/reducer';
import { merchantListReducer } from './merchantList/reducer';
import { referralsReducer } from './referrals/reducer';

// Combine your reducers
const appReducers = combineReducers({
  loader: loaderReducer,
  auth: AuthReducer,
  profile: ProfileReducer,
  ChangeLayoutMode,
  customer: CustomerReducer,
  user: userReducer,
  payment: paymentReducer,
  package: packageReducer,
  master: masterReducer,
  source: sourceReducer,
  salesAgent: salesAgentReducer,
  packageSource: packageSourceReducer,
  merchantRegistration: merchantRegistrationReducer,
  merchantList: merchantListReducer,
  referrals: referralsReducer,
});

// Reset root reducer on logout
// const rootReducer = (state, action) => {
//   if (action.type === 'RESET_ALL_DATA') {
//     return appReducers({});
//   }
//   return appReducers(state, action);
// };
const rootReducer = (state, action) => {
  if (action.type === 'RESET_ALL_DATA') {
    return appReducers(undefined, action);
  }
  return appReducers(state, action);
};

export default rootReducer;
